import React, { memo } from 'react'
import { LaneArrowIcon } from 'transfix-icons/build'
import { makeStyles } from 'transfix-ui/core'
import Typography from 'transfix-ui/core/Typography'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'

export const useLanePickupDeliveryStyles = makeStyles(theme => ({
  laneContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  laneArrow: {
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${theme.spacing(1)}`,
  },
  laneRadius: {
    margin: `0 0 0 ${theme.spacing(0.5)}`,
  },
}))

export interface ILanePickupDeliveryProps
  extends Pick<
    BookableShipmentSavedSearch,
    | 'pickupCity'
    | 'pickupStateCode'
    | 'pickupMiles'
    | 'deliveryCity'
    | 'deliveryStateCode'
    | 'deliveryMiles'
  > {}

const LanePickupDelivery = memo<ILanePickupDeliveryProps>(
  ({
    deliveryCity,
    deliveryMiles,
    deliveryStateCode,
    pickupCity,
    pickupMiles,
    pickupStateCode,
  }) => {
    const classes = useLanePickupDeliveryStyles()

    const showPickupMiles: boolean = !!pickupMiles && pickupMiles > 0
    const showDeliveryMiles: boolean = !!deliveryMiles && deliveryMiles > 0
    return (
      <div className={classes.laneContainer}>
        <Typography
          variant='subtitle1'
          data-test='saved-lane-pickup-location'>{`${pickupCity}, ${pickupStateCode}`}</Typography>
        {showPickupMiles && (
          <div className={classes.laneRadius} data-test='saved-lane-pickup-radius'>
            <Typography variant='caption' color='textSecondary'>
              +{pickupMiles}
            </Typography>
          </div>
        )}
        <div className={classes.laneArrow}>
          <LaneArrowIcon size='large' />
        </div>
        {deliveryCity && deliveryStateCode ? (
          <>
            <Typography
              variant='subtitle1'
              data-test='saved-lane-delivery-location'>{`${deliveryCity}, ${deliveryStateCode}`}</Typography>
            {showDeliveryMiles && (
              <div className={classes.laneRadius} data-test='saved-lane-delivery-radius'>
                <Typography variant='caption' color='textSecondary'>
                  +{deliveryMiles}
                </Typography>
              </div>
            )}
          </>
        ) : (
          <Typography variant='subtitle1' data-test='saved-lane-delivery-location'>
            Anywhere
          </Typography>
        )}
      </div>
    )
  }
)

export default LanePickupDelivery
